/**
 * 格式化时间
 * @param {Number} value 单位：秒
 */
export default function formatTime(value?: number | null): string | null | undefined {
  if (typeof value !== 'number') return value;

  let str = '';

  const days = Math.floor(value / 864e2);
  if (days > 0) {
    str += `${days}d`;
  }

  const hours = Math.floor(value / 36e2) % 24;
  if (hours > 0) {
    str += `${hours}h`;
  }

  const minutes = Math.floor(value / 60) % 60;
  if (minutes > 0) {
    str += `${minutes}m`;
  }

  const seconds = value % 60;
  if (seconds > 0) {
    str += `${seconds}s`;
  }

  return str;
}
